export default "__VITE_ASSET__OgeKao9z__"